import { Route } from "@angular/router";
import { AuthGuard } from "../guards/auth.guard";
import { OperationsGuard } from "../guards/operations.guard";

export const CurriculumTreeRoutes: Route[] = [
  {
    path: "curriculum-tree",
    loadComponent: () =>
      import("../../Feature/curriculum-tree/pages/curriculum-tree/curriculum-tree.component").then(
        (mod) => mod.CurriculumTreeComponent
      ),
    pathMatch: "full",
    canActivate: [AuthGuard, OperationsGuard],
  },
];
